import { LivenessStep, markLivenessStep } from './liveness-step-tracker.helper';

// Neither the AWS Amplify detector nor the Incode SDK tells the host when the
// camera actually starts, but both open it through getUserMedia. Wrapping it
// gives one vendor-neutral CAMERA_STARTED step: the first time a live video
// stream is handed out for the current transaction. Pass-through only — the
// stream, errors and constraints are untouched.
export function installCameraStartTracking(): void {
    if (typeof navigator === 'undefined' || !navigator.mediaDevices?.getUserMedia) return;

    const mediaDevices = navigator.mediaDevices as MediaDevices & { __pjCameraStartTrackingInstalled?: boolean };
    if (mediaDevices.__pjCameraStartTrackingInstalled) return;
    mediaDevices.__pjCameraStartTrackingInstalled = true;

    const originalGum = mediaDevices.getUserMedia.bind(mediaDevices);
    mediaDevices.getUserMedia = async (constraints?: MediaStreamConstraints): Promise<MediaStream> => {
        const stream = await originalGum(constraints);
        try {
            const videoTrack = stream.getVideoTracks?.()[0];
            if (videoTrack && videoTrack.readyState === 'live') {
                markLivenessStep(LivenessStep.CAMERA_STARTED, {
                    cameraFacingMode: videoTrack.getSettings?.().facingMode ?? null,
                });
            }
        } catch {
            // Datadog must never break the liveness flow
        }
        return stream;
    };
}
